"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherTransactions = exports.Transactions = void 0;
var React = require("react");
var TransactionsAction_1 = require("@/pages/common/actions/TransactionsAction");
var react_redux_1 = require("react-redux");
var ResultPagination_1 = require("@/pages/search/components/ResultPagination");
var format_1 = require("@/utils/format");
var isMultiBuildings_1 = require("@/pages/common/transformers/isMultiBuildings");
var mapDispatchToProps = function (dispatch) { return ({
    onChangePage: function (page) {
        return dispatch(TransactionsAction_1.default.onTransactionChangePage(page));
    },
    onTransactionLinkClicked: function (url) {
        return dispatch(TransactionsAction_1.default.onTransactionLinkClicked(url));
    },
}); };
var mapStateToProps = function (state, ownProps) { return ({
    transactions: state.transactions,
    buildingName: ownProps.buildingName,
    resultT: ownProps.resultT,
    lang: ownProps.lang,
    symbolHkd: ownProps.symbolHkd,
}); };
var mapOtherStateToProps = function (state, ownProps) { return ({
    transactions: state.otherTransactions,
    buildingName: ownProps.buildingName,
    resultT: ownProps.resultT,
    lang: ownProps.lang,
    symbolHkd: ownProps.symbolHkd,
}); };
var transactions = function (props) {
    var buildingNameSeo = props.buildingName
        ? format_1.default.normalize(props.buildingName)
        : "";
    var multiBuildings = isMultiBuildings_1.isMultiBuildings(props.transactions.transactions);
    var renderTransactionRow = function (record, multiBuildings, lang, symbolHkd, buildingNameSeo, t, i) {
        var href = buildingNameSeo
            ? "/" + lang + "/property/transaction/" + buildingNameSeo + "/" + record.id
            : "/" + lang + "/property/transaction/" + record.id;
        var rowClicked = function () { return props.onTransactionLinkClicked(href); };
        var name = isMultiBuildings_1.getName(record);
        return (React.createElement("tr", { onClick: rowClicked, key: i, className: "c-estate__history-tr " + (multiBuildings ? " c-estate__history-tr-md " : "") },
            React.createElement("td", { className: "c-estate__history-td" },
                React.createElement("a", { href: href }, record.date)),
            multiBuildings ? (React.createElement("td", { className: "c-estate__history-td" }, name)) : null,
            React.createElement("td", { className: "c-estate__history-td" }, record.floor || "-"),
            React.createElement("td", { className: "c-estate__history-td" }, record.unit || "-"),
            React.createElement("td", { className: "c-estate__history-td c-estate__history-td--price" }, format_1.default.currencySale(record.price, props.lang, symbolHkd + " ")),
            React.createElement("td", { className: "c-estate__history-td" }, record.priceChangeSinceDate || "-"),
            React.createElement("td", { className: "c-estate__history-td" },
                React.createElement("div", { className: "" + (record.priceChangePercent > 0
                        ? "c-estate__history-td--win"
                        : record.priceChangePercent < 0
                            ? "c-estate__history-td--lose"
                            : "") }, record.priceChangePercent !== 0 ? (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "fas " + (record.priceChangePercent > 0
                            ? "fa-caret-up"
                            : record.priceChangePercent < 0
                                ? "fa-caret-down"
                                : "") }),
                    "\u00A0",
                    React.createElement("span", null,
                        record.priceChangePercent,
                        "%"))) : ("-"))),
            React.createElement("td", { className: "c-estate__history-td" },
                React.createElement("div", { className: "" + (record.priceAnnualReturn > 0
                        ? "c-estate__history-td--win"
                        : record.priceAnnualReturn < 0
                            ? "c-estate__history-td--lose"
                            : "") }, record.priceAnnualReturn !== 0 ? (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "fas " + (record.priceAnnualReturn > 0
                            ? "fa-caret-up"
                            : record.priceAnnualReturn < 0
                                ? "fa-caret-down"
                                : "") }),
                    "\u00A0",
                    React.createElement("span", null,
                        record.priceAnnualReturn,
                        "%"))) : ("-"))),
            React.createElement("td", { className: "c-estate__history-td" }, record.size
                ? record.size + " " + (record.sizeUnit === "g" ? "" + t.grossAbbr : "" + t.saleableAbbr)
                : "-"),
            React.createElement("td", { className: "c-estate__history-td" }, record.size
                ? format_1.default.currencyPpsf(Math.floor(record.price / record.size), props.symbolHkd + " ") + " " + (record.sizeUnit === "g" ? "" + t.grossAbbr : "" + t.saleableAbbr) + " "
                : "")));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "l-pad" },
            React.createElement("table", { className: "c-estate__history" },
                React.createElement("thead", null,
                    React.createElement("tr", { className: "c-estate__history-tr c-estate__history-tr--head " + (multiBuildings ? " c-estate__history-tr-md " : "") },
                        React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionDate),
                        multiBuildings ? (React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionName)) : null,
                        React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionFloor),
                        React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionFlat),
                        React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionPrice),
                        React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionLastRegDate),
                        React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionLastRegChange),
                        React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionAnnualReturn),
                        React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionSize),
                        React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.transactions.t.transactionPpsf))),
                React.createElement("tbody", null, props.transactions.transactions.map(function (it, i) {
                    return renderTransactionRow(it, multiBuildings, props.lang, props.symbolHkd, buildingNameSeo, props.transactions.t, i);
                })))),
        props.transactions.transactionTotalPage > 1
            ? ResultPagination_1.renderPagination(props.transactions.transactionCurrentPage, props.transactions.transactionTotalPage, props.onChangePage, props.resultT)
            : null));
};
exports.Transactions = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(transactions);
exports.OtherTransactions = react_redux_1.connect(mapOtherStateToProps, mapDispatchToProps)(transactions);
